export const ServerUrl = 'https://footbalancetech.com/footserver/public';
//export const ServerUrl = 'http://127.0.0.1:8000'